module.exports = __webpack_public_path__ + "static/media/gts19.fe65dbcf.png";